import React from "react";
import ReactDOM, {createRoot} from "react-dom/client";
import App from "./App";
import "./index.css";
import NotificationPanel from "./components/NotificationPanel";

const randerNotification = () => {
  const target = document.querySelector('[app36-element="notification"]');
  console.log("target", target)
  if (target) {
    const root = createRoot(target);
    root.render(<NotificationPanel />);
  }
}

window.addEventListener("message", (event: MessageEvent) => {
  if (event.data.messageType === "RENDER_NOTIFICATION") {
    randerNotification()
  }
})


/*document.addEventListener("DOMContentLoaded", (event) => {
  setTimeout(randerNotification, 2000);
});*/

document.addEventListener("readystatechange", (event: any) => {
  if (document.readyState === "interactive") {
    const container = document.body.appendChild(document.createElement("div"));
    const root = ReactDOM.createRoot(container);
    root.render(<App />);
  }
});

